export class Proyecto_Anticipo_Liquidacion {
  folioAnticipoLiquidacion: number = -1;
  idProyecto: number = 0;
  fondeoUnidad: number = 0;
  anticipo?: number = 0;
  liquidacion?: number = 0;
  idUsuarioUM: number;
  fondeoUnidadMonto?: number = 0;
  tipoFondeo?: number = 0;
}
